import React from 'react'
import styled from "styled-components";
import {Image, Divider, Message, Label} from 'semantic-ui-react';

import { __ } from '~/i18n'
import SelectListItem from '~/components/select-list-item'

const NameContainer = styled.span`
  line-height: 42px;
  display: inline-block;
`;

const GrayInactiveImage = styled(({ active, ...rest }) => <Image {...rest} />)`
  &.ui.image {
    margin: 0 !important;
    ${props => props.active ? '' : 'filter: gray;' }
    ${props => props.active ? '' : '-webkit-filter: grayscale(1);'}
    ${props => props.active ? '' : 'filter: grayscale(1);'}
  }
`;

const StyledLabel = styled(({...rest}) =>  <Label {...rest}/>)`
  &.ui.label {
    margin-left: auto;
    align-self: center;
  }
`;

export default class PaymentMethod extends React.PureComponent {
  handleClick = (e) => {
    const { selectMethod, paymentMethod } = this.props;

    if(selectMethod) {
      selectMethod(paymentMethod);
    }
  };

  render() {
    const { active, image, name, instructions, extra } = this.props;
    return (
      <SelectListItem
        size='big' active={ active }
        onClick={ this.handleClick }
        title={[
          image ? <GrayInactiveImage active={ active } key='image' style={{height: 42}} verticalAlign='middle' src={ image } /> : (name ? <NameContainer key='name'>{ name }</NameContainer> : null),
          extra ? <StyledLabel key="extra">{ extra }</StyledLabel> : null
        ]}
      >
        { active && instructions ?
          <div>
            <Divider />
            <Message size='mini'>
              <Message.Header>{ __('Instructions') }</Message.Header>
              <p>
                { instructions }
              </p>
            </Message>
          </div>
          : null
        }
      </SelectListItem>
    )
  }
}
